import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.scala = bracketIndenting()
